import './step_section.scss';
import { Link } from 'react-router-dom';
import { removeBaseUrl } from '../../utils';
export const StepSection = ({
    fields
}) => {
    return <section id="step-section" className="home-section">
        <div className="container">
            <div className='section-header'>
                <h2>{ fields?.steps_section_title ?? 'Next Step'}</h2>
            </div>

            <div className='step-wrapper'>
                <div className='step-repeater'>
                    {
                        fields?.steps_repeater?.map((it, index) => <div className="block-item" key={index}>
                        <span className="block-icon" dangerouslySetInnerHTML={{__html: it?.block_icon}}></span>
                        <span className="block-title">{index+1}. {it?.block_title}</span>
                        <span className="block-details">{it?.block_content}</span>
                      </div>)
                    }
                </div>
            </div>
        </div>
    </section>
}